import DialogContent from '@mui/material/DialogContent'
import { styled } from '@mui/material/styles'

import { AppDialogContentProps } from './types'

const AppDialogContentWrapper = styled(DialogContent, {
    shouldForwardProp: (prop) => prop !== 'dense' && prop !== 'scrollPaper',
})<AppDialogContentProps>(({ theme, dense, scrollPaper }) => ({
    padding: dense ? 0 : theme.spacing(2),
    ...(scrollPaper && {
        maxHeight: '90vh',
        overflowY: 'auto',
    }),
}))

export default AppDialogContentWrapper
